"use client";

import { I18nextProvider } from "react-i18next";
import { initTranslations } from "./i18n";
import { createInstance } from "i18next";
import { PropsWithChildren } from "react";

export function TranslationsProvider({
  children,
  locale,
  namespaces,
  resources,
}: PropsWithChildren<{
  locale: string;
  namespaces: string[];
  resources: unknown;
}>) {
  const i18n = createInstance();

  initTranslations(locale, namespaces, i18n, resources);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
